import React from "react";
import Html from "./Html";
import Markdown from "./Markdown";
import Paragraph from "./Paragraph";
import Video from "./Video";
import Image from "./Image";

interface paramsProps {
  block: {
    _uid?: string
    component: "simple-paragraph" | "markdown" | "html" | "image-url" | "video-url" | string
    body: string
  }
}

function BlogComponents({ block }: paramsProps) {

  type componentsType = "simple-paragraph" | "markdown" | "html" | "image-url" | "video-url"

  const Components = {
    'simple-paragraph': Paragraph,
    'markdown': Markdown,
    'html': Html,
    'image-url': Image,
    'video-url': Video
  };

  if (typeof (Components as unknown as Record<string, componentsType | undefined>)[block.component] !== "undefined") {
    return React.createElement((Components as unknown as Record<string, componentsType>)[block.component], {
      key: block._uid,
      block: block
    });
  }
  return React.createElement(
    () => <div>The component {block.component} has not been created yet.</div>,
    { key: block._uid }
  );
}

export default BlogComponents;
